import _ from 'lodash';
import {showAlert} from './alertActions';

let dataFetchError = 'Error fetching data';

export const showDataFetchError = (exception) => {
    return (dispatch) => {
        dispatch(
            showAlert({
                type: 'danger',
                title: 'Error',
                content: dataFetchError + (!_.isEmpty(exception) ? ': ' + exception : ''),
                //showCancel: true,
              })
        );
    }
}

export const showInfoMessasge = (infoMessage) => {
    return (dispatch) => {
        dispatch(
            showAlert({
                type: 'info',
                title: 'Information',
                content: infoMessage,
                //showCancel: true,
              })
        );
    }
}
